import React, { FC, useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'
import styles from 'styles/components/form.module.scss'
import 'react-image-crop/dist/ReactCrop.css'
import { Spacer } from 'components/Utility'
import { FlexColumn, FlexRow } from 'components/Flex'
import { FileUploadButton, TextButton } from 'components/Button'
import heic2any from 'heic2any'
import { uploadImage } from 'lib/storage'
import { useDispatch } from 'react-redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { ImageDropzone } from 'components/Form'

type Props = {
  folderPath: string
  handleImageUrl: (value: string) => void
  imageName: 'banner' | 'main_visual' | 'background' | 'icon' | 'pointCardOffer' | 'storeLogo'
  imageUrl: string
}

const ImageUploader: FC<Props> = (props) => {
  const { folderPath, handleImageUrl, imageName, imageUrl } = props
  const dispatch = useDispatch()
  const [acceptedFiles, setAcceptedFiles] = useState<File[]>([])
  const handleAcceptedFiles = useCallback(
    (files: File[]) => {
      setAcceptedFiles([...files])
    },
    [setAcceptedFiles]
  )

  const onSelectFile = async (file: File) => {
    const reader = new FileReader()
    // HEIC形式はそのままでは使えないのでJPEGに変換する
    if (file.type === 'image/heic') {
      dispatch(showLoadingAction())
      const blob = file as Blob
      const convertedBlob = await heic2any({
        blob,
        toType: 'image/jpeg',
        quality: 1,
      })
      dispatch(hideLoadingAction())
      reader.readAsDataURL(convertedBlob as Blob)
    } else {
      reader.readAsDataURL(file)
    }

    reader.onload = async () => {
      if (typeof reader.result !== 'string') return
      await uploadImage(file, file.type, folderPath, handleImageUrl)
    }
  }

  useEffect(() => {
    if (acceptedFiles.length === 0) return
    onSelectFile(acceptedFiles[0])
  }, [acceptedFiles])

  const deleteImage = useCallback(() => {
    handleImageUrl('')
  }, [handleImageUrl])

  return (
    <ImageDropzone maxAcceptableFiles={1} handleAcceptedFiles={handleAcceptedFiles}>
      <div
        className={classNames({
          [styles.image__list__item__box__banner]: imageName === 'banner',
          [styles.image__list__item__box__mainVisual]: imageName === 'main_visual',
          [styles.image__list__item__box__background]: imageName === 'background',
          [styles.image__list__item__box__icon]: imageName === 'icon',
          [styles.image__list__item__box__pointCardOffer]: imageName === 'pointCardOffer',
        })}
      >
        {imageUrl === '' ? (
          <div className={styles.image__list__item__content} />
        ) : (
          <img className={styles.image__list__item__content_uploaded} src={imageUrl} alt={''} />
        )}
      </div>
      {imageUrl === '' ? (
        <FlexColumn alignItems={'center'}>
          <Spacer size={16} />
          <FileUploadButton
            id={imageName}
            label={'画像をアップロードする'}
            onSelectFile={onSelectFile}
            type={'button'}
          />
        </FlexColumn>
      ) : (
        <>
          <Spacer size={8} />
          <FlexRow justifyContent={'end'}>
            <TextButton iconPath={'/icon/blue/delete_28x28.svg'} label={'削除'} onClick={deleteImage} />
          </FlexRow>
        </>
      )}
    </ImageDropzone>
  )
}

export default ImageUploader
